import axios from '../base/axios';
import API_KEY from './key';

const GET_HORROR = 'flixfrenzy/redux/GET_HORROR';

// eslint-disable-next-line default-param-last
const horrorReducer = (state = [], action) => {
  switch (action.type) {
    case GET_HORROR:
      return action.payload;
    default:
      return state;
  }
};

export const getHorror = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=27`).then((res) => {
    dispatch({
      type: GET_HORROR,
      payload: res.data,
    });
  });
};

export default horrorReducer;
